import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from "@material-ui/core/IconButton";
import axios from "axios";
import './SpecialNotification.css'
import * as  notificationService from '../../../services/SpecialNotificationService';



class SpecialNotification extends React.Component {
    state = {
        viewNotification: false,
        closeError: true,
        noticeTimestamp: '',
        noticeHeader: '',
        noticeMsg: ''
    };

    constructor(props) {
        super(props);

    }

    async componentDidMount() {
        await notificationService.getSpecialNotification().then(res => {
            if (res.success){

                if (res.body.noticeHeader != null){
                    let d = new Date((res.body.noticeTimestamp)),
                        month = '' + (d.getMonth() + 1),
                        day = '' + d.getDate(),
                        year = d.getFullYear();
                    this.setState({viewNotification: true});
                    this.setState({noticeTimestamp: ('Updated On ' + day + ' /' + month + ' /' + year)});
                    this.setState({noticeHeader: res.body.noticeHeader});
                    this.setState({noticeMsg: res.body.noticeMsg})
                }else{
                    this.setState({viewNotification: false})
                }
            }
        }).catch(async (error) => {
            console.log(error);
        });
    }
    render() {
        return (
            <div>
                {this.state.viewNotification === true ?
                    <div className={this.state.closeError ? 'detailsStyle' : 'closeErrorMassage'}>
                        <IconButton  style={{ color: 'white' }} className='buttonIcon' aria-label="delete" size="small" onClick={() => {
                            this.setState(
                                {'closeError': false}
                            );
                        }}>
                            <CloseIcon fontSize="large"/>
                        </IconButton>
                        <h6 className='errorUpdate'>{this.state.noticeTimestamp}</h6>
                        <br/>
                        <h6 className='textDetails'>{this.state.noticeHeader}</h6>
                        <p className='errorMassage'>{this.state.noticeMsg}</p>
                    </div> : null
                }
            </div>
        )
    }
}


export default SpecialNotification;

